import { render, staticRenderFns } from "./WaSideMenuCategory.vue?vue&type=template&id=6f250a10"
import script from "./WaSideMenuCategory.vue?vue&type=script&lang=js"
export * from "./WaSideMenuCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports